export default "__VITE_ASSET__Wxpdq4w$__"